import moment from 'moment';
import { authenticatedFetch } from '@forwardfinancing/component-library';
import {statementsURL} from '../actions/statementsActions';

export default {
  formatDate(date=null) {
    if (date && moment(date).isValid()) {
      return moment(date).utc().startOf('day');
    }
  },

  formatDateToString(date=null) {
    const formattedDate = this.formatDate(date);

    return formattedDate? formattedDate.format('MM/DD/YYYY') : '';
  },

  exportPDF(id) {
      return authenticatedFetch(`${statementsURL()}/${id}.pdf`, {
        method: 'GET',
        headers: {
          'Accept': 'application/pdf',
          'Content-Type': 'application/pdf'
        },
         responseType: 'blob'
      })
      .then(response => {
        const filename = response.headers.get('Filename');
        return { blob: response.blob(), filename };
    })
      .then(({blob, filename}) => {
        return blob.then((blob) => {
          const data = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = data;
          link.download= filename;
          link.click();
        });
      });
    }
};
